module.exports = __webpack_public_path__ + "img/indent.90e1cbe6.svg";